import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import "../components/carousel.css";
import Divider from '@material-ui/core/Divider'

let HelperImg = require('../../src/assets/img/ayudante.svg')

const styles = {
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `1rem`,
  },
  leftImage: {
    width: '4rem',
    margin: '0.15rem',
    paddingRight: 5,
  },
  typoFontC: {
    fontFamily: "'Open Sans', sans-serif",
    lineHeight: '1.2rem',
    fontSize: '0.8rem',
    margin: 5,
    maxWidth: '11rem',
  },
  subtitleSection: {
    fontFamily: "'Open Sans', sans-serif",
    lineHeight: '1.3rem',
    fontSize: '1.1rem',
    margin: 5,
    fontWeight: 'bold'
  },
  listStyle: {
    background: '#E4E4E4',
    padding: 5,
    marginBottom: 0,
    fontFamily: '"Open Sans", sans-serif'
  },
  linkStyle: {
    color: '#408ed6',
  }
}

const RecomendadosPage = (props) => (
  <div>
    <h1 style={{color: '#3A3380', fontSize: '1.25rem', textAlign: 'center', fontWeight: 'bold', marginTop: '1rem'}}>
      Bibliografía Consultada y Recomendada
    </h1>
    <Grid container spacing={24}>
      <Grid item xs={12} sm={5}>
        <div style={{display: 'flex', justifyContent: 'center' }}>
          <img src={HelperImg} alt="" style={{width: '12rem', height: '12rem', margin: '0.5rem'}} />
        </div>
        <Typography variant="body2" color='caption' style={{marginBottom: 10, fontFamily: "'Indie Flower', sans-serif", fontSize: '1rem'}}>
          Nos gustaría recomendarte estos libros, para que puedas aprender un poquito más de historia
        </Typography>
      </Grid>
      <Grid item xs={12} sm={7}>
        <Grid container alignItems="center" justify='center' spacing={16} >

          <Grid item xs={12} sm={12} alignItems="center" justify='center'
                style={{display: 'flex', marginRight: 10, background: '#e1ded4', padding: '2rem'}}>
            <div className='recomendados'>
              <ul style={{listStyleType: 'square'}}>
                <li style={styles.listStyle} >
                  La Argentina: Una historia para pensar 1776-1996. Cristina Rins, María Felisa Winter. Kapelusz. 1999.
                </li>
                <li style={styles.listStyle} >
                  Juan Manuel de Rosas: el maldito de nuestra historia oficial. Pacho O’Donnell. Booket. 2001.
                </li>
                <li style={styles.listStyle} >
                  Martirologio Patrio. Marcial Quiroga. Compañía Impresora Argentina. 1991.
                </li>
                <li style={styles.listStyle} >
                  Juan Manuel de Rosas: El caudillo y su tiempo. Felisberto López Sarabia. Ediciones Libertador. 2007.
                </li>
                <li style={styles.listStyle} >
                  La Gran Epopeya. Pacho O’Donnell. Grupo Editorial Norma. 2010.
                </li>
                <li style={styles.listStyle} >
                  El Gaucho Martín Fierro. José Hernández. Imprenta de La Pampa. 1872.
                </li>
                <li style={styles.listStyle} >
                  Juan Manuel de Rosas: El Restaurador Político. Colección Bicentenario. Biografías Planeta. Alejandro Ulloa. 2009.
                </li>
                <li style={styles.listStyle} >
                  Revoluciones: Estallidos políticos y soluciones constitucionales. Félix Luna. Planeta. 2006.
                </li>
                <li style={styles.listStyle} >
                  Correspondencia de Juan Manuel de Rosas. Marcela Ternavasio. Eudeba. 2005.
                </li>
                <li style={styles.listStyle} >
                  José Artigas: El Caudillo Revolucionario. Colección Bicentenario. Biografías Planeta. Alejandro Ulloa. 2009.
                </li>
                <li style={styles.listStyle} >
                  Cosa Funesta: El enigma de la muerte de Moreno. Diego Golombek. Editorial Sudamericana. 2004.
                </li>
                <li style={styles.listStyle} >
                  Historia Política de las Américas: De los orígenes a la emancipación. Hugo Chumbita. Universidad Nacional de La Matanza. 2010.
                </li>
              </ul>
              <h1 style={{color: '#3A3380', fontSize: '1rem', textAlign: 'center', fontWeight: 'bold', marginTop: '1rem'}}>
                Además tenemos para recomendar otros sitios de Historia y páginas amigas:
              </h1>
              <ul style={{listStyleType: 'square'}}>
                <li style={styles.listStyle} >
                  <a style={styles.linkStyle} href="https://www.elhistoriador.com.ar/" target="_blank" >El Historiador - de Felipe Pigna</a>
                </li>
                <li style={styles.listStyle} >
                  <a style={styles.linkStyle} href="https://www.efemeridesargentina.com.ar/efemeridesargentina/" target="_blank" >Efemérides de Argentina</a>
                </li>
                <li style={styles.listStyle} >
                  <a style={styles.linkStyle} href="http://encuentro.gob.ar/" target="_blank" >Canal Encuentro</a>
                </li>
                <li style={styles.listStyle} >
                  <a style={styles.linkStyle} href="https://historiaybiografias.com/historia_argentina/" target="_blank" >Historia y Biografías de Argentina</a>
                </li>
              </ul>
              <Divider style={{margin: 10}}/>
              {/* <ul style={{listStyleType: 'square'}}>
                <li style={styles.listStyle} >
                  <a style={styles.linkStyle} href="http://yunikusoft.com/" target="_blank" >Yuniku Software Development</a>
                </li>
                <li style={styles.listStyle} >
                  <a style={styles.linkStyle} href="http://www.cheleo.com.ar/" target="_blank" >CheLeo - Blog sobre el trabajo en la industria de software</a>
                </li>
                {/* <li style={styles.listStyle} >
                  <a style={styles.linkStyle} href="http://mauricioblint.com/" target="_blank" >Mauricio Blint - Desarrollador de Software Freelance</a>
                </li> 
              </ul> */}
            </div>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </div>
)

export default RecomendadosPage



// WEBPACK FOOTER //
// ./src/pages/recomendados.js